module.exports = __webpack_public_path__ + "assets/img/main_ru.29fc984e.png";